export default "__VITE_ASSET__CoF8EabP__"